import { render, staticRenderFns } from "./RoleList.vue?vue&type=template&id=6c268042"
import script from "./RoleList.vue?vue&type=script&lang=js"
export * from "./RoleList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports